import React from "react";
import { RULES, TAGS } from "../../../constants/rules";
import { messages } from "../../../constants/intl";
import { generateSectionConfig } from "@carrier-ecat/ngecat-commonworkflowui";
import { Select, InputRange, RadioGroup } from '@carrier-ecat/ngecat-tsreactcomponents';
import { Typography } from "@carrier-ecat/ngecat-tsreactcomponents";
import Air from '@material-ui/icons/AcUnit';
const conditions = generateSectionConfig(RULES, [TAGS.UI_SEL, TAGS.UI_SEL_DC, TAGS.UI_SEL_DC_CONS], {
    label: 'Conditions',
    id: 'section-model',
    icon: () => React.createElement(Air, null),
    components: [
        {
            direction: "column",
            size: 3,
            cells: [
                {
                    component: React.createElement(Typography, { align: "center" }, messages.FACILITY_LOOP),
                    props: { visible: true },
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_SLEAVINGAIRFACILITYLOOP },
                    component: React.createElement(RadioGroup, { name: "Selection", row: true })
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_FLEAVINGAIRTEMPFACILITYLOOP },
                    component: React.createElement(InputRange, { label: messages.DC_FLEAVINGAIRTEMPFACILITYLOOP.defaultMessage })
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_FLEAVINGFLUIDFLOWFACILITYLOOP },
                    component: React.createElement(InputRange, { label: messages.DC_FLEAVINGFLUIDFLOWFACILITYLOOP.defaultMessage })
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_SFLUIDTYPEFACILITYLOOP },
                    component: React.createElement(Select, { label: messages.DC_SFLUIDTYPEFACILITYLOOP.defaultMessage })
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_FFLUIDCONCFACILITYLOOP },
                    component: React.createElement(InputRange, { label: messages.DC_FFLUIDCONCFACILITYLOOP.defaultMessage })
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_NMAXPRESSUREDROP },
                    component: React.createElement(InputRange, { label: messages.DC_NMAXPRESSUREDROP.defaultMessage })
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_SENTERINGAIRFACILITYLOOP },
                    component: React.createElement(RadioGroup, { name: "Selection", row: true })
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_FENTERINGAIRTEMPFACILITYLOOP },
                    component: React.createElement(InputRange, { label: messages.DC_FENTERINGAIRTEMPFACILITYLOOP.defaultMessage })
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_FENTERINGFLUIDFLOWFACILITYLOOP },
                    component: React.createElement(InputRange, { label: messages.DC_FENTERINGFLUIDFLOWFACILITYLOOP.defaultMessage })
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_NALTITUDE },
                    component: React.createElement(InputRange, { label: messages.DC_NALTITUDE.defaultMessage })
                },
            ]
        },
        {
            direction: "column",
            size: 1,
            cells: []
        },
        {
            direction: "column",
            size: 4,
            cells: [
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_ICDUREFERENCE },
                    component: (rule) => (React.createElement("img", { width: '100%', src: rule.media, alt: "Coolant Distribution Unit" })),
                    props: { visible: true }
                }
            ]
        },
        {
            direction: "column",
            size: 1,
            cells: []
        },
        {
            direction: "column",
            size: 3,
            cells: [{
                    component: React.createElement(Typography, { align: "center" }, messages.TECH_LOOP),
                    props: { visible: true }
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_SLEAVINGAIRTECHLOOP },
                    component: React.createElement(RadioGroup, { name: "Selection", row: true })
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_FLEAVINGAIRTEMPTECHLOOP },
                    component: React.createElement(InputRange, { label: messages.DC_FLEAVINGAIRTEMPTECHLOOP.defaultMessage })
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_FLEAVINGFLUIDFLOWTECHLOOP },
                    component: React.createElement(InputRange, { label: messages.DC_FLEAVINGFLUIDFLOWTECHLOOP.defaultMessage })
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_SFLUIDTYPETECHLOOP },
                    component: React.createElement(Select, { label: messages.DC_SFLUIDTYPETECHLOOP.defaultMessage })
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_FFLUIDCONCTECHNOLOGYLOOP },
                    component: React.createElement(InputRange, { label: messages.DC_FFLUIDCONCTECHNOLOGYLOOP.defaultMessage })
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_NSTATICPRESSUREDROP },
                    component: React.createElement(InputRange, { label: messages.DC_NSTATICPRESSUREDROP.defaultMessage })
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_SENTERINGAIRTECHLOOP },
                    component: React.createElement(RadioGroup, { name: "Selection", row: true })
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_FENTERINGAIRTEMPTECHLOOP },
                    component: React.createElement(InputRange, { label: messages.DC_FENTERINGAIRTEMPTECHLOOP.defaultMessage })
                },
                {
                    rule: { name: RULES.UI_SEL_DC_CONS.DC_FENTERINGFLUIDFLOWTECHLOOP },
                    component: React.createElement(InputRange, { label: messages.DC_FENTERINGFLUIDFLOWTECHLOOP.defaultMessage })
                }]
        },
    ]
});
export default conditions;
